import Layout from '@layout/Index'

export const platformRole = [
  {
    path: '/platform-role',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "PlatformRoleTable" */ './pages/PlatformRoleTable.vue'),
        name: '后台用户角色管理',
        meta: {
          title: '后台用户角色管理',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "PlatformRoleForm" */ './pages/PlatformRoleForm.vue'),
        name: '新增后台用户角色',
        meta: {
          title: '新增后台用户角色',
        },
      },
      {
        path: 'update/:roleId',
        component: () => import(/* webpackChunkName: "PlatformRoleForm" */ './pages/PlatformRoleForm.vue'),
        name: '编辑后台用户角色',
        meta: {
          title: '编辑后台用户角色',
        },
      },
    ],
  },
  {
    path: '/platform-role/ui-role',
    component: Layout,
    children: [
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "PlatformRoleUiRoleForm" */ './pages/PlatformUiRoleForm.vue'),
        name: '新增UI权限角色',
        meta: {
          title: '新增UI权限角色',
        },
      },
      {
        path: 'update/:roleId',
        component: () => import(/* webpackChunkName: "PlatformRoleUiRoleForm" */ './pages/PlatformUiRoleForm.vue'),
        name: '编辑UI权限角色',
        meta: {
          title: '编辑UI权限角色',
        },
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/platform-role/platform-role.route.js